/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'navigation.global-shortcuts.all-sites': 'Všechny weby',
  'navigation.global-shortcuts.apps.align': 'Zarovnání',
  'navigation.global-shortcuts.apps.analytics': 'Analytika',
  'navigation.global-shortcuts.apps.assets': 'Aktiva',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Centrum společnosti',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Zaměření',
  'navigation.global-shortcuts.apps.goals': 'Cíle',
  'navigation.global-shortcuts.apps.home': 'Domovská obrazovka',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projekty',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Týmy',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Zavřít',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Web {name}',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(momentálně nedostupné)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Ikona Otevřít externí odkaz',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(načítání)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(načítání)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'otevřít nabídku',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': 'Weby {productName}',
};
